import { useMemo } from 'react';
import { useGetApproversQuery } from '../../__generated__/chirp/com/hubspot/product/approvals/rpc/ApprovalsConfigurationRpc.hooks';
import { APPROVAL_TYPE_TO_OBJECT_TYPE_ID } from 'ui-product-approvals-common/constants/approvalTypeIds';
import { useAppHubUsers } from './useAppHubUsers';
import { useBreezeAgents } from './useBreezeAgents';
import { captureException } from '../utils/sentryUtils';
import { actorToApprovalUser } from '../utils/approvalResponseAdapters';
import { ACTOR } from '../constants/actors';
export const useApprovers = (approvalType, approvalAction) => {
  const {
    data: queryData,
    loading: queryLoading,
    error: queryError
  } = useGetApproversQuery({
    variables: {
      approvalTypeId: APPROVAL_TYPE_TO_OBJECT_TYPE_ID[approvalType],
      approvalAction
    },
    onError: error => {
      captureException(error, {
        extra: {
          fingerprint: 'useApprovers',
          approvalType,
          approvalAction
        }
      });
    }
  });
  const actorUserIds = useMemo(() => {
    if (!(queryData !== null && queryData !== void 0 && queryData.approvers)) return [];
    return queryData.approvers.filter(actor => actor.actorType === ACTOR.USER).map(actor => Number(actor.id));
  }, [queryData]);
  const actorAgentIds = useMemo(() => {
    if (!(queryData !== null && queryData !== void 0 && queryData.approvers)) return [];
    return queryData.approvers.filter(actor => actor.actorType === ACTOR.AGENT).map(actor => actor.id);
  }, [queryData]);
  const {
    usersRecord,
    loading: usersLoading,
    error: usersError
  } = useAppHubUsers({
    userIds: actorUserIds
  });
  const {
    agentsRecord,
    loading: agentsLoading
  } = useBreezeAgents({
    agentIds: actorAgentIds
  });
  const approvers = useMemo(() => {
    if (!(queryData !== null && queryData !== void 0 && queryData.approvers) || usersLoading || agentsLoading) return [];
    return queryData.approvers.map(actor => actorToApprovalUser(actor, usersRecord, agentsRecord));
  }, [queryData, usersRecord, usersLoading, agentsRecord, agentsLoading]);
  return {
    approvers,
    isLoading: queryLoading || usersLoading || agentsLoading,
    isError: Boolean(queryError) || Boolean(usersError)
  };
};